define('modules/page_generator/views/desktop_preview',['require','exports','module','./base_preview','../service','ldsh!../templates/preview'],function(require, exports, module){
  "use strict";
  var BasePreview = require("./base_preview"),
      PageGenerator = require("../service");

  module.exports = BasePreview.extend({
    template: require("ldsh!../templates/preview"),
    onPreviewRender: function(){

    }
  });
});
